import "./index.scss";
function Join() {   
    return (
        <div className="join_container">
            <div className="text">
                <h1>加入我們！</h1>
                <h1>Join US!</h1>
                <p>
                    開始對區塊鏈感興趣了嗎?想了解更多與區塊鏈相關的資訊嗎?加入我們社團吧！除了每週二都會有的社課外，我們還會不定時送出活動票券，讓各位可以有更多的收益！<br/>
                    無論是區塊鏈新手，或是老練的韭菜，都歡迎加入到北科大區塊鏈社團！<br/>
                    你可以選擇使用虛擬貨幣，或是新台幣支付社費。<br/>
                    我們的社費是以學期為單位，學生為 700 新台幣或 20 USDt, 而非學生則為 1500 新台幣或 45 USDt。<br/>
                    請注意，新台幣僅接受現金支付，而 USDt 僅接受 Arbitrum 網路。<br/>
                    準備好了嗎？<br/>
                </p>
                <a className="join_us" href="https://forms.gle/ujojLJjK2A7cf5jQ7" target="_blank" rel="noopener noreferrer"> 加入我們吧！</a>
            </div>
        </div>
    );
}

export default Join;